import { useEffect } from 'react'

import { usePagination } from '@/atoms'

import { BulkEdit } from './edit/BulkEdit'
import { List } from './List'
import { EditExecutionEvents } from './edit/SingleEdit/ExecutionEvents'
import { EditOrderStep } from './edit/SingleEdit/OrderStep'
import { SinglePreview } from './preview/SinglePreview'
import { BulkPreview } from './preview/BulkPreview'
import { TabValues } from './typings'
import { useOrdersRoot } from './useOrdersRoot'

export function OrdersRoot() {
  const { editing, orders, selectedOrders, selection, resetOrdersFilter } = useOrdersRoot()

  const bulk = selectedOrders.length > 1
  const single = selectedOrders.length === 1

  const { page, setPage } = usePagination('orderTab')

  const order = selectedOrders[0]

  useEffect(() => {
    return () => {
      // Set the order form to the first tab (configuration)
      setPage(0)
      resetOrdersFilter()
    }
  }, [setPage, resetOrdersFilter])

  return (
    <>
      <List editing={editing} orders={orders} selection={selection} tab={page as TabValues} />
      {single && !editing && order && (
        <SinglePreview
          extOrder={order}
          tab={page as TabValues}
          setTab={setPage}
          selection={selection}
        />
      )}
      {bulk && !editing && <BulkPreview orders={selectedOrders} />}
      {editing && !bulk && (
        <>
          {page === 0 && <EditOrderStep order={order} tab={page} />}
          {page === 1 && order && <EditExecutionEvents order={order} tab={page} />}
        </>
      )}
      {editing && bulk && <BulkEdit orders={selectedOrders} />}
    </>
  )
}
